import React, { Component } from "react";
import { connect } from "react-redux";
import {
  changeView,
  nextOpenQuestion,
  setOpenQuestionAnswerText,
} from "../actions/assessment";
import { SaveUserStateToServerHelper } from "./Helper";

import { Translate } from "react-redux-i18n";
import Button from "./ui/Buttons/Button";

export class OpenQuestionForm1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.question_number !== prevProps.question_number) {
      SaveUserStateToServerHelper(this.props.assessment);
    }
  }

  nextQuestion(question_number, answer, question_type) {
    if (question_type === 1) {
      if (answer === "") {
        this.setState({ error: "Please answer the question." });
        return;
      } else if (answer.length > 3000) {
        this.setState({
          error: "Please limit your answer to 3000 characters.",
        });
        return;
      }

      const oq_answer = this.props.open_questions_answers;
      const nextAnswerValue = oq_answer?.[question_number]
        ? oq_answer[question_number]
        : "";
      this.props.setAnswerText(nextAnswerValue);

      let question_index = question_number - 1;
      this.props.next_open_question(question_index, answer);
    } else {
      let question_index = question_number - 1;
      this.props.next_open_question(question_index, answer);
    }
  }

  handleChange(event) {
    this.setState({ error: "" });
    this.props.setAnswerText(event.target.value);
  }

  render() {
    const { question, question_number, question_type, choices } = this.props;

    return (
      <div className="main container-fluid h-100 mt-lg-0 mt-xs-5">
        <div className="row test-container align-items-md-center">
          <div className="col-12">
            <div className="container">
              <div className="row  justify-content-center ">
                <div className="col-md-12">
                  <div className="test-info ">
                    <h5 className="mt-4 mb-3 text-black-50 font-weight-bold">
                      Question {question_number}
                    </h5>
                    <h6 className="mt-4 mb-3 text-black-50">{question}</h6>

                    <form className="form-custom">
                      <div className="row">
                        <div className="col-12">
                          {question_type === 1 && (
                            <div className="form-label-group">
                              <textarea
                                className="form-control"
                                rows="10"
                                spellCheck="false"
                                placeholder="Type response here."
                                name="open_question_answer"
                                id="open_question_answer"
                                value={this.props.answer_text}
                                onChange={this.handleChange}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      {question_type === 1 && (
                        <div className="row">
                          <div className="col-6">
                            {this.state.error.length > 0 && (
                              <span className="error">{this.state.error}</span>
                            )}
                          </div>
                          <div className="col-6">
                            <p className="text-right">
                              {this.props.answer_text.length}/3000
                            </p>
                          </div>
                        </div>
                      )}
                    </form>

                    {question_type === 1 && (
                      <div className="button-wrap my-5">
                        {/* <button
                          onClick={() =>
                            this.nextQuestion(
                              question_number,
                              this.props.answer_text,
                              question_type,
                            )
                          }
                          className="btn btn-main btn-global d-block d-lg-inline-block"
                        >
                          <Translate value="next" />
                        </button> */}
                        <Button
                          variant="primary"
                          className="btn-global d-block d-lg-inline-block"
                          onClick={() =>
                            this.nextQuestion(
                              question_number,
                              this.props.answer_text,
                              question_type,
                            )
                          }
                        >
                          <Translate value="next" />
                        </Button>
                      </div>
                    )}

                    {question_type === 2 &&
                      choices.map((choice) => {
                        return (
                          <div
                            data-toggle="buttons"
                            key={choice.id + choice.text}
                          >
                            <label
                              key={choice.id}
                              className="btn btn-outline-dark"
                              style={{
                                minWidth: "100%",
                                textAlign: "left",
                              }}
                              onClick={() => {
                                const selected_answer =
                                  choice.letter + ". " + choice.text;
                                this.nextQuestion(
                                  question_number,
                                  selected_answer,
                                  question_type,
                                );
                              }}
                            >
                              <input
                                type="radio"
                                key={choice.id}
                                name="options"
                                id={"custom_question_choice" + choice.id}
                                value={choice.letter + " " + choice.text}
                              />
                              <span className="letter-choice">
                                {choice.letter + ". "}
                              </span>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: choice.text,
                                }}
                              ></span>
                            </label>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  instruction: state.assessment.exams[state.assessment.exam_index].instruction,
  is_ptsd: state.assessment.exams[state.assessment.exam_index].is_ptsd,
  question:
    state.assessment.open_questions[state.assessment.current_oq_number].text,
  question_type:
    state.assessment.open_questions[state.assessment.current_oq_number].type,
  question_number: state.assessment.current_oq_number + 1,
  open_questions_answers: state.assessment.open_questions_answers,
  answer_text: state.assessment.current_oq_answer_text,
  choices:
    state.assessment.open_questions[state.assessment.current_oq_number].choices,
});

const mapDispatchToProps = (dispatch) => ({
  show_job_application_form2: () =>
    dispatch(changeView("job_application_form2")),
  next_open_question: (current_index, answer) =>
    dispatch(nextOpenQuestion(current_index, answer)),
  setAnswerText: (text) => dispatch(setOpenQuestionAnswerText(text)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OpenQuestionForm1);
